import User from "@/models/User";
import ConcernedInfo from "@/models/ConcernedInfo";

export default class DailyReportItem {
    id
    creator
    createDate
    updater
    updateDate
    url
    title
    concerned
    webSiteName
    webSiteUrl
    area
    customerName
    openDate
    fetchDate
    publishDate
    operateType
    operateTypeTag


    static OP_TYPE_SUGGEST = "SUGGEST"

    static OP_TYPE_CONTINUE = "CONTINUE"

    static OP_TYPE_UNUSED = "UNUSED"

    constructor(props) {
        const pp = props || {}

        this.id = pp.id || ''
        this.creator = new User(pp.creator)
        this.createDate = pp.createDate
        this.updater = new User(pp.updater)
        this.updateDate = pp.updateDate
        this.url = pp.url || ''
        this.title = pp.title || ''
        this.concerned = new ConcernedInfo(pp.concerned)
        this.webSiteName = pp.webSiteName || ''
        this.webSiteUrl = pp.webSiteUrl || ''
        this.area = pp.area || ''
        this.customerName = pp.customerName || ''
        this.openDate = pp.openDate
        this.fetchDate = pp.fetchDate
        this.publishDate = pp.publishDate
        this.operateType = pp.operateType || ''
        this.operateTypeTag = pp.operateTypeTag || '未确定'
        this.highlightWords = pp.highlightWords || ''

        this.unused = this.operateType === DailyReportItem.OP_TYPE_UNUSED

        this.suggest = this.operateType === DailyReportItem.OP_TYPE_SUGGEST

        this.continue = this.operateType === DailyReportItem.OP_TYPE_CONTINUE

        this.firstLevelArea = (this.area || '').split("/")[0]

        this.highlightTitles = []

        if (this.highlightWords) {
            this.highlightTitles = this.highlightWords.split(",")
        }
    }

}
